module.exports = __webpack_public_path__ + "img/lookbook_2_center.54c0629b.png";